// Meghalaya trip data — exact content from theunexploredroutes.com
const meghalayaTrip = {
  _id: '2',
  title: 'Meghalaya Exploration',
  destination: 'Shillong, Cherrapunji & Dawki, Meghalaya',
  description: 'MEGHALAYA — The Abode of Clouds. From Scotland of the East (Shillong at 4908 ft) to the wettest place on Earth (Cherrapunji at 4,400 ft), trek to the UNESCO World Heritage Double Decker Living Root Bridge, roam freely at the India-Bangladesh border at Dawki, and experience adventure activities at Krang Suri Falls. A backpacking journey through the most extraordinary landscape in Northeast India.',
  duration: '5N/6D',
  price: 14999,
  originalPrice: 18000,
  maxGroupSize: 15,
  difficulty: 'Easy',
  category: 'Offbeat',
  coverImage: '/meghalaya.jpg',
  rating: 4.8,
  reviewCount: 62,
  featured: true,
  highlights: [
    'Shillong — Scotland of the East (4908 ft above sea level)',
    'Cherrapunji — Wettest place in the world (4,400 ft)',
    'Trek to Double Decker Living Root Bridge (UNESCO World Heritage)',
    'Mawlynnong — Asia\'s Cleanest Village',
    'Dawki — India-Bangladesh Border, crystal clear Umngot River',
    'Krang Suri Falls — cliff jumping, kayaking, snorkeling',
    'Elephant Falls, Shillong Peak, Mawsmai Cave',
  ],
  itinerary: [
    {
      day: 1,
      title: 'Day 1 — Reach Guwahati and Transfer to Shillong via Umiam Lake',
      description: 'Meet upon arrival at Guwahati Airport / Railway Station.\n\nAfter the initial introduction, we travel to Shillong which is famously known as the Scotland of the East and is at an altitude of 4908 feet above sea level.\n\nEnroute visit Umiam Lake.\n\nExplore Cafes and Local market of Shillong in the evening.\n\nOvernight stay in Shillong.',
      accommodation: 'Hotel/Homestay/Guest house in Shillong',
      meals: 'Dinner',
      image: '/meghalaya.jpg',
    },
    {
      day: 2,
      title: 'Day 2 — Shillong to Cherrapunji via Laitlum',
      description: 'Breakfast will be served in the morning.\n\nAfter that, the group will head towards Cherrapunji (4,400 ft.), the wettest place in the world.\n\nEn route, the group will visit Elephant Falls and Shillong peak for a short sightseeing tour.\n\nThe rest of the day will be spent visiting waterfall between Shillong and Cherapunjee followed by exploring Mawsmai cave in the evening.\n\nOvernight stay at Cherrapunji.',
      accommodation: 'Hotel/Homestay/Guest house in Cherrapunji',
      meals: 'Breakfast & Dinner',
      image: 'https://images.pexels.com/photos/2739664/pexels-photo-2739664.jpeg?auto=compress&cs=tinysrgb&w=600&h=400&fit=crop',
    },
    {
      day: 3,
      title: 'Day 3 — Trek to Double Decker Bridge',
      description: 'After early breakfast, the group will head for trekking towards one of the UNESCO World Heritage sites — Double Decker Living Root Bridge. If time permits, we shall go exploring and trekking to the Rainbow Falls as well.\n\nReturn to Cherrapunji by evening.\n\nOvernight stay at Cherrapunji.',
      accommodation: 'Hotel/Homestay/Guest house in Cherrapunji',
      meals: 'Breakfast & Dinner',
      image: '/meghalaya.jpg',
    },
    {
      day: 4,
      title: 'Day 4 — Cherrapunji Sightseeing, Drive to Mawlynnong and Stay at Dawki',
      description: 'We\'ll have an early breakfast, after which we\'ll explore the various places in Cherrapunji including the cave sites, the Nohkalikai waterfall, and the seven sister falls.\n\nLater on, we\'ll continue on the road-trip further to Mawlynnong, also known as Asia\'s Cleanest Village.\n\nAfterward, we\'ll drive to Dawki, from there the India-Bangladesh Border is just 2 hours away. In here, you can roam around in between the India-Bangladesh border which is an unbarbed area free of any strict army vigilance, unlike most border areas.\n\nFinally, we\'ll head down to our riverside camps.\n\nPost-check-in, we\'ll have dinner and bonfire.\n\nOvernight at the campsite in Dawki.',
      accommodation: 'Riverside Camps in Dawki',
      meals: 'Breakfast, Dinner & Bonfire',
      image: 'https://images.pexels.com/photos/2739664/pexels-photo-2739664.jpeg?auto=compress&cs=tinysrgb&w=600&h=400&fit=crop',
    },
    {
      day: 5,
      title: 'Day 5 — Dawki to Krang Suri Falls to Shillong',
      description: 'After breakfast, the rest of the day is for adventure activities.\n\nThe group will head off for adventure activities including cliff jumping, kayaking, snorkeling, and more. All the adventure activities would be at your personal expenses.\n\nLater, we\'ll drive towards Krang Suri waterfalls and afterwards back to Shillong with an evening at leisure.\n\nGuests are free to explore the city in the evening as this will be the last day for the Meghalaya backpacking trip and by this time, we would have already covered all our itinerary checkpoints.\n\nOvernight Stay at Shillong.',
      accommodation: 'Hotel/Homestay/Guest house in Shillong',
      meals: 'Breakfast & Dinner',
      image: '/meghalaya.jpg',
    },
    {
      day: 6,
      title: 'Day 6 — Shillong to Guwahati (Tour Ends)',
      description: 'Breakfast will be served in the morning.\n\nPost breakfast, the group will drive from Shillong to Guwahati.\n\nOn reaching Guwahati, you can head back home according to your own convenience.\n\nThe tour ends and we\'ll conclude our Meghalaya backpacking trip.\n\n*You are advised to book flights for Day 6 as the group will be reaching Guwahati around 5 PM, booking your flight tickets accordingly.',
      accommodation: '-',
      meals: 'Breakfast',
      image: 'https://images.pexels.com/photos/2739664/pexels-photo-2739664.jpeg?auto=compress&cs=tinysrgb&w=600&h=400&fit=crop',
    },
  ],
  inclusions: [
    'Transportation for all the 6 Days from Guwahati to Guwahati',
    'Accommodation on double/triple sharing basis',
    'Two nights accommodation (hotel/homestay/guest house stay) in Shillong',
    'Two nights accommodation (hotel/homestay/guest house) in Cherrapunji',
    'One night accommodation (camps) in Dawki',
    'Dinner and Breakfast in Dawki (shnongpdeng)',
    'Breakfasts in Shillong and Cherrapunji',
    'Bonfire at Dawki',
    'First aid kits',
    'Infrared thermometer',
    'Oximeter',
    'Toll Taxes',
    'Driver Allowances',
  ],
  exclusions: [
    'Any place entry fees, guide fees etc.',
    'Expenses on any activities which are not mentioned in the itinerary',
    'Any type of insurance including travel, health, and more',
    'Expenses of personal nature are not covered',
    'Additional expense added due to unforeseen circumstances such as cancellation/roadblocks/landslides/strike or any other natural causes would not be covered',
    'Anything not mentioned in Inclusions',
    'We would not be liable for theft/misplaced items',
  ],
  paymentTerms: [
    '50% Advance to confirm the reservation',
    'Balance 50% Payment before Departure of Trip at Leh',
  ],
  thingsToPack: [
    'Rucksack (60 Liters+)',
    'Daypack',
    'Backpack Rain Cover',
    'Suncap',
    'UV Protected Sunglasses',
    'Comfortable Pants (Prefer Cargo/Trek Pants)',
    'Raincoat/Poncho',
    'Socks (2 Cotton)',
    'Slippers',
    'Sturdy Comfortable Shoes',
    'Towels',
    'First Aid Kit',
    'Personal Medication',
  ],
  greeting: 'Dear Sir/Mam, Greetings from The Unexplored Routes!!! Thank you for providing me the opportunity for your holiday plans. I am pleased to attach suggested programme along with our very competitive price. I hope you like it. Best Regards, Manik Punjabi — The Unexplored Routes — 8109849232',
};

export default meghalayaTrip;
